import React from 'react';

import cls from '@soluto-design/styles/cls';

export interface DataItemProps {
    value: string;
    className?: string;
    component?: React.ElementType;
}

const DataItem = ({
    value,
    className,
    component: Component = 'span',
}: DataItemProps) => {
    const formattedValue = value
        .trim()
        .split(/(\d+|\D+)/)
        .filter(Boolean)
        .map((item, index) => {
            if (typeof item !== 'string') return null;

            let formattedItem = item.trim();

            if (isNaN(parseFloat(formattedItem))) {
                // This part of the string is non-numeric
                return (
                    <span
                        key={index}
                        className={cls(
                            index === 0 && ['+', '-'].includes(formattedItem)
                                ? 'text-h100 text-text-primary'
                                : ['.'].includes(formattedItem)
                                ? 'text-h300 text-text-primary'
                                : 'text-b200 text-text-primary ml-8',
                        )}>
                        {item}
                    </span>
                );
            }

            // This part of the string is numeric
            return (
                <span
                    key={index}
                    className={cls('text-h100 text-text-primary')}>
                    {item}
                </span>
            );
        });

    return (
        <Component className={cls('block', className)}>
            {formattedValue}
        </Component>
    );
};

export default DataItem;
